<div class="modal-header">
  <h4 class="modal-title">
    {{ (isRename ? 'chat.sections.renameTitle' : 'chat.sections.newTitle') | translate }}
  </h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<form [formGroup]="sectionForm" (ngSubmit)="save()">
  <div class="modal-body">
    <div class="mb-1">
      <label class="form-label" for="chatSectionName">{{ 'chat.sections.name' | translate }}</label>
      <input
        id="chatSectionName"
        type="text"
        class="form-control"
        formControlName="name"
        maxlength="40"
        [placeholder]="'chat.sections.namePlaceholder' | translate"
      >
      <span class="help-block"><small class="text-muted">{{ 'chat.sections.hint' | translate }}</small></span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.dialog.cancel' | translate }}</button>
    <button type="submit" class="btn btn-primary" [disabled]="sectionForm.invalid || submitting">
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        <span>{{ 'chat.sections.saving' | translate }}</span>
      } @else {
        <span>{{ (isRename ? 'chat.sections.save' : 'chat.sections.create') | translate }}</span>
      }
    </button>
  </div>
</form>
